// extracted by mini-css-extract-plugin
export default {"confirmationModal":"styles_confirmationModal__GXy+E","confirmationModalContainer":"styles_confirmationModalContainer__m7MrH","messageContainer":"styles_messageContainer__8MR2A"};